module.exports = __webpack_public_path__ + "img/shg55_samurai01skin_shop.5d04ce13.png";